// CYBORG-1354: why a message is held beyond "the cybo is mid-run". Absent = the
// original busy-queue hold. Unknown reasons from a newer relay fall back to that.
export type HoldReason = "awaiting_owner_share" | "share_unavailable";

export function parseHoldReason(r: unknown): HoldReason | undefined {
  return r === "awaiting_owner_share" || r === "share_unavailable" ? r : undefined;
}

// Pill copy for the share-hold reasons (the busy-queue copy stays in ChatMessage).
// `agent` is the handle or name, null when the roster has no match.
export function holdPillCopy(
  reason: HoldReason,
  agent: string | null,
  ownerName: string | null | undefined,
  write = false,
): string {
  const verb = write ? "write" : "share";
  if (reason === "awaiting_owner_share") {
    return `Waiting for ${ownerName || "the owner"} to approve ${write ? "writing this" : "sharing this"}`;
  }
  return `${agent ?? "The agent"} couldn't get permission to ${verb} that`;
}
